import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
};

export type Attachment = {
  __typename?: 'Attachment';
  attached: Scalars['Boolean']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export enum BackStyle {
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Rounded (Abgerundet) */
  Rounded = 'ROUNDED',
  /** Straight (Gerade) */
  Straight = 'STRAIGHT'
}

export type Booking = {
  __typename?: 'Booking';
  bookingCode: Scalars['String']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  daysSinceLastBooking: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  manual: Scalars['Boolean']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  service: Service;
  serviceExecution?: Maybe<ServiceExecution>;
  store: Store;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitingTime: Scalars['Int']['output'];
};

export type BookingTransactionDataInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  kidCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  silentBooking?: InputMaybe<Scalars['Boolean']['input']>;
  storeSlug: Scalars['String']['input'];
};

export type BreakTime = {
  __typename?: 'BreakTime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  duration: Scalars['Int']['output'];
  employee: Employee;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  store: Store;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum BroadcastOperation {
  /** A new record is being added */
  Add = 'ADD',
  /** A record is being removed */
  Remove = 'REMOVE',
  /** A record is being updated */
  Update = 'UPDATE'
}

/** Autogenerated input type of CallNextCustomer */
export type CallNextCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CallNextCustomer. */
export type CallNextCustomerPayload = {
  __typename?: 'CallNextCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

export type CheckIn = {
  __typename?: 'CheckIn';
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CheckIn */
export type CheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckIn. */
export type CheckInPayload = {
  __typename?: 'CheckInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of CheckOut */
export type CheckOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckOut. */
export type CheckOutPayload = {
  __typename?: 'CheckOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

export enum CheckoutEnum {
  /** Both */
  Both = 'BOTH',
  /** Instant */
  Instant = 'INSTANT',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** Autogenerated input type of ConvertPreBooking */
export type ConvertPreBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preBookingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertPreBooking. */
export type ConvertPreBookingPayload = {
  __typename?: 'ConvertPreBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  preBooking?: Maybe<PreBooking>;
};

export type Coupon = {
  __typename?: 'Coupon';
  bookingsCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  maxUses: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  usesLeft: Scalars['Int']['output'];
};

/** Autogenerated input type of CreateBooking */
export type CreateBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBooking. */
export type CreateBookingPayload = {
  __typename?: 'CreateBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of CreateBookingTransaction */
export type CreateBookingTransactionInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: BookingTransactionDataInput;
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of CreateBookingTransaction. */
export type CreateBookingTransactionPayload = {
  __typename?: 'CreateBookingTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreatePassPurchase */
export type CreatePassPurchaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePassPurchase. */
export type CreatePassPurchasePayload = {
  __typename?: 'CreatePassPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  passPurchase?: Maybe<PassPurchase>;
};

/** Autogenerated input type of CreatePassTransaction */
export type CreatePassTransactionInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: PassPurchaseTransactionDataInput;
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of CreatePassTransaction. */
export type CreatePassTransactionPayload = {
  __typename?: 'CreatePassTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreatePreBooking */
export type CreatePreBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePreBooking. */
export type CreatePreBookingPayload = {
  __typename?: 'CreatePreBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  preBooking?: Maybe<PreBooking>;
};

/** Autogenerated input type of CreatePreBookingTransaction */
export type CreatePreBookingTransactionInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: PreBookingTransactionDataInput;
  paymentMethod: PaymentMethod;
};

/** Autogenerated return type of CreatePreBookingTransaction. */
export type CreatePreBookingTransactionPayload = {
  __typename?: 'CreatePreBookingTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreateReview */
export type CreateReviewInput = {
  bookingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: ReviewInput;
};

/** Autogenerated return type of CreateReview. */
export type CreateReviewPayload = {
  __typename?: 'CreateReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  review?: Maybe<Review>;
};

export type Customer = {
  __typename?: 'Customer';
  avgReviewScore: Scalars['Float']['output'];
  bookingsCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invalidPhone: Scalars['Boolean']['output'];
  lastBookingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  preferences: CustomerPreferences;
  settings?: Maybe<CustomerSettings>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CustomerPreferences = {
  __typename?: 'CustomerPreferences';
  backStyle?: Maybe<BackStyle>;
  cutEyebrows: Scalars['Boolean']['output'];
  ears?: Maybe<EarStyle>;
  hairLength?: Maybe<HairLength>;
  layers: Scalars['Boolean']['output'];
  lengthSides?: Maybe<Scalars['Int']['output']>;
  lengthTop?: Maybe<Scalars['Int']['output']>;
  neckline?: Maybe<Neckline>;
  notes?: Maybe<Scalars['String']['output']>;
  parting?: Maybe<Parting>;
  submittedPreferences: Scalars['Boolean']['output'];
};

export type CustomerPreferencesInput = {
  backStyle?: InputMaybe<BackStyle>;
  cutEyebrows?: InputMaybe<Scalars['Boolean']['input']>;
  ears?: InputMaybe<EarStyle>;
  hairLength?: InputMaybe<HairLength>;
  layers?: InputMaybe<Scalars['Boolean']['input']>;
  lengthSides?: InputMaybe<Scalars['Int']['input']>;
  lengthTop?: InputMaybe<Scalars['Int']['input']>;
  neckline?: InputMaybe<Neckline>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parting?: InputMaybe<Parting>;
  submittedPreferences: Scalars['Boolean']['input'];
};

export type CustomerSettings = {
  __typename?: 'CustomerSettings';
  loyaltyMessages: Scalars['Boolean']['output'];
  personalizedOffers: Scalars['Boolean']['output'];
  serviceMessages: Scalars['Boolean']['output'];
};

export type CustomerSettingsInput = {
  loyaltyMessages: Scalars['Boolean']['input'];
  personalizedOffers: Scalars['Boolean']['input'];
  serviceMessages: Scalars['Boolean']['input'];
};

export enum EarStyle {
  /** Covered (bedeckt) */
  Covered = 'COVERED',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Uncovered (frei) */
  Uncovered = 'UNCOVERED'
}

export type Employee = {
  __typename?: 'Employee';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentBreak?: Maybe<BreakTime>;
  currentCheckIn?: Maybe<CheckIn>;
  currentServiceExecution?: Maybe<ServiceExecution>;
  id: Scalars['ID']['output'];
  lastActionStore?: Maybe<Store>;
  name: Scalars['String']['output'];
  serviceExecutionsCount: Scalars['Int']['output'];
  state: StylistState;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Employee. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Employee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Employee>;
};

/** Autogenerated input type of EndBreak */
export type EndBreakInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of EndBreak. */
export type EndBreakPayload = {
  __typename?: 'EndBreakPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of EndService */
export type EndServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of EndService. */
export type EndServicePayload = {
  __typename?: 'EndServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

export enum ExpireUnit {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS'
}

export enum HairLength {
  /** Long (Lang) */
  Long = 'LONG',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Short (Kurz) */
  Short = 'SHORT'
}

/** Autogenerated input type of HoldService */
export type HoldServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of HoldService. */
export type HoldServicePayload = {
  __typename?: 'HoldServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

export type Mutation = {
  __typename?: 'Mutation';
  callNextCustomer?: Maybe<CallNextCustomerPayload>;
  checkIn?: Maybe<CheckInPayload>;
  checkOut?: Maybe<CheckOutPayload>;
  convertPreBooking?: Maybe<ConvertPreBookingPayload>;
  createBooking?: Maybe<CreateBookingPayload>;
  createBookingTransaction?: Maybe<CreateBookingTransactionPayload>;
  createPassPurchase?: Maybe<CreatePassPurchasePayload>;
  createPassTransaction?: Maybe<CreatePassTransactionPayload>;
  createPreBooking?: Maybe<CreatePreBookingPayload>;
  createPreBookingTransaction?: Maybe<CreatePreBookingTransactionPayload>;
  createReview?: Maybe<CreateReviewPayload>;
  endBreak?: Maybe<EndBreakPayload>;
  endService?: Maybe<EndServicePayload>;
  holdService?: Maybe<HoldServicePayload>;
  queueService?: Maybe<QueueServicePayload>;
  snoozeReminder?: Maybe<SnoozeReminderPayload>;
  startBreak?: Maybe<StartBreakPayload>;
  startService?: Maybe<StartServicePayload>;
  storeSignIn?: Maybe<StoreSignInPayload>;
  updatePreferences?: Maybe<UpdatePreferencesPayload>;
  updateSettings?: Maybe<UpdateSettingsPayload>;
  validateCoupon?: Maybe<ValidateCouponPayload>;
  /** @deprecated This mutation is deprecated. Use validate_phone_number instead. */
  validatePhoneCustomer?: Maybe<ValidatePhoneCustomerPayload>;
  validatePhoneNumber?: Maybe<ValidatePhoneNumberPayload>;
};


export type MutationCallNextCustomerArgs = {
  input: CallNextCustomerInput;
};


export type MutationCheckInArgs = {
  input: CheckInInput;
};


export type MutationCheckOutArgs = {
  input: CheckOutInput;
};


export type MutationConvertPreBookingArgs = {
  input: ConvertPreBookingInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBookingTransactionArgs = {
  input: CreateBookingTransactionInput;
};


export type MutationCreatePassPurchaseArgs = {
  input: CreatePassPurchaseInput;
};


export type MutationCreatePassTransactionArgs = {
  input: CreatePassTransactionInput;
};


export type MutationCreatePreBookingArgs = {
  input: CreatePreBookingInput;
};


export type MutationCreatePreBookingTransactionArgs = {
  input: CreatePreBookingTransactionInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationEndBreakArgs = {
  input: EndBreakInput;
};


export type MutationEndServiceArgs = {
  input: EndServiceInput;
};


export type MutationHoldServiceArgs = {
  input: HoldServiceInput;
};


export type MutationQueueServiceArgs = {
  input: QueueServiceInput;
};


export type MutationSnoozeReminderArgs = {
  input: SnoozeReminderInput;
};


export type MutationStartBreakArgs = {
  input: StartBreakInput;
};


export type MutationStartServiceArgs = {
  input: StartServiceInput;
};


export type MutationStoreSignInArgs = {
  input: StoreSignInInput;
};


export type MutationUpdatePreferencesArgs = {
  input: UpdatePreferencesInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationValidateCouponArgs = {
  input: ValidateCouponInput;
};


export type MutationValidatePhoneCustomerArgs = {
  input: ValidatePhoneCustomerInput;
};


export type MutationValidatePhoneNumberArgs = {
  input: ValidatePhoneNumberInput;
};

export enum Neckline {
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Straight (gerade) */
  Straight = 'STRAIGHT',
  /** Tapered (auslaufend) */
  Tapered = 'TAPERED'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum Parting {
  /** Left (links) */
  Left = 'LEFT',
  /** Middle (Mitte) */
  Middle = 'MIDDLE',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Right (rechts) */
  Right = 'RIGHT'
}

export type Pass = {
  __typename?: 'Pass';
  active: Scalars['Boolean']['output'];
  basePrice: Scalars['Int']['output'];
  bookingsPaid: Scalars['Int']['output'];
  customColor: Scalars['String']['output'];
  expireUnit: ExpireUnit;
  id: Scalars['ID']['output'];
  maxUses: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  purchasesCount: Scalars['Int']['output'];
  specialPromotion: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  timeToExpire: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** The connection type for Pass. */
export type PassConnection = {
  __typename?: 'PassConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PassEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Pass>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PassEdge = {
  __typename?: 'PassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Pass>;
};

export type PassPurchase = {
  __typename?: 'PassPurchase';
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  pass: Pass;
  paymentTransaction?: Maybe<PaymentTransaction>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PassPurchaseTransactionDataInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  passGid: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  storeSlug?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentMethod {
  /** Apple Pay */
  Apl = 'APL',
  /** Direct */
  Direct = 'DIRECT',
  /** EC */
  Eca = 'ECA',
  /** PayPal */
  Pay = 'PAY',
  /** Skip */
  Skip = 'SKIP',
  /** TWINT */
  Twi = 'TWI',
  /** Unknown */
  Unk = 'UNK',
  /** Visa */
  Vis = 'VIS'
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  data?: Maybe<PaymentTransactionData>;
  datatransId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: PaymentMethod;
  purchaseType: PurchaseType;
  reference: Scalars['String']['output'];
  status: PaymentTransactionStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PaymentTransactionData = {
  __typename?: 'PaymentTransactionData';
  couponCode?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  kidCustomer: Scalars['Boolean']['output'];
  manual: Scalars['Boolean']['output'];
  passGid?: Maybe<Scalars['ID']['output']>;
  phoneNumber: Scalars['String']['output'];
  silentBooking?: Maybe<Scalars['Boolean']['output']>;
  storeSlug?: Maybe<Scalars['String']['output']>;
};

export enum PaymentTransactionStatus {
  Authenticated = 'AUTHENTICATED',
  Authorized = 'AUTHORIZED',
  /** Legacy */
  Cancel = 'CANCEL',
  Canceled = 'CANCELED',
  ChallengeOngoing = 'CHALLENGE_ONGOING',
  ChallengeRequired = 'CHALLENGE_REQUIRED',
  /** The default status */
  Created = 'CREATED',
  /** Legacy */
  Error = 'ERROR',
  Failed = 'FAILED',
  Initialized = 'INITIALIZED',
  Settled = 'SETTLED',
  Success = 'SUCCESS',
  Transmitted = 'TRANSMITTED',
  Uncomplete = 'UNCOMPLETE'
}

export type PreBooking = {
  __typename?: 'PreBooking';
  bookTime: Scalars['ISO8601DateTime']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  service: Service;
  store: Store;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PreBookingBroadcast = {
  __typename?: 'PreBookingBroadcast';
  operation: BroadcastOperation;
  preBooking: PreBooking;
};

/** The connection type for PreBooking. */
export type PreBookingConnection = {
  __typename?: 'PreBookingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PreBookingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PreBooking>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PreBookingEdge = {
  __typename?: 'PreBookingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PreBooking>;
};

export type PreBookingTransactionDataInput = {
  bookTime: Scalars['ISO8601DateTime']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  kidCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  silentBooking?: InputMaybe<Scalars['Boolean']['input']>;
  storeSlug: Scalars['String']['input'];
};

export enum PurchaseType {
  /** Transaction for a booking */
  Booking = 'BOOKING',
  /** Transaction for a DRYCUT pass */
  Pass = 'PASS'
}

export type Query = {
  __typename?: 'Query';
  /** Get a booking based on its uid. */
  booking?: Maybe<Booking>;
  /** Get business hours for a store (GlobalID). */
  businessHours: StoreBusinessHours;
  /** Get checked in stylists for the authenticated store. */
  checkedInStylists: EmployeeConnection;
  /** Get a coupon by code. */
  coupon?: Maybe<Coupon>;
  /** Get a customer by code. */
  customer?: Maybe<Customer>;
  /** Get a pass by ID (GlobalID). */
  pass?: Maybe<Pass>;
  /** Get a pass purchase by uid. */
  passPurchase?: Maybe<PassPurchase>;
  /** Get active passes */
  passes: PassConnection;
  /** Get a payment transaction by ID (GlobalID). */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** Get a pre booking based on its uid. */
  preBooking?: Maybe<PreBooking>;
  /** Get pre-bookings in the future, not cancelled by store ID (GlobalID). */
  preBookings: PreBookingConnection;
  /** Get the service executions of the authenticated store to populate the queues. */
  serviceExecutions: ServiceExecutionConnection;
  /** Get a store by slug. */
  store?: Maybe<Store>;
  /** Get the pre bookings of the authenticated store for the current day. */
  storePreBookings: PreBookingConnection;
  /** Get active stores */
  stores: StoreConnection;
  /** Get active stylists. */
  stylists: EmployeeConnection;
};


export type QueryBookingArgs = {
  uid: Scalars['String']['input'];
};


export type QueryBusinessHoursArgs = {
  storeId: Scalars['ID']['input'];
};


export type QueryCheckedInStylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCouponArgs = {
  code: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  code: Scalars['String']['input'];
};


export type QueryPassArgs = {
  passId: Scalars['ID']['input'];
};


export type QueryPassPurchaseArgs = {
  uid: Scalars['String']['input'];
};


export type QueryPassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentTransactionArgs = {
  paymentTransactionId: Scalars['ID']['input'];
};


export type QueryPreBookingArgs = {
  uid: Scalars['String']['input'];
};


export type QueryPreBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  storeId: Scalars['ID']['input'];
};


export type QueryServiceExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStoreArgs = {
  slug: Scalars['String']['input'];
};


export type QueryStorePreBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStoresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCheckedOut?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of QueueService */
export type QueueServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of QueueService. */
export type QueueServicePayload = {
  __typename?: 'QueueServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

/** A record error */
export type RecordError = {
  __typename?: 'RecordError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Review = {
  __typename?: 'Review';
  booking: Booking;
  customer: Customer;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
  store: Store;
};

export type ReviewInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};

export type Service = {
  __typename?: 'Service';
  id: Scalars['ID']['output'];
  kidsPrice?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
};

export type ServiceExecution = {
  __typename?: 'ServiceExecution';
  booking: Booking;
  calledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer?: Maybe<Customer>;
  employee?: Maybe<Employee>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  held: Scalars['Boolean']['output'];
  heldAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  noPauseAfterEnded: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  projectedBookTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  projectedWaitingTime: Scalars['Int']['output'];
  reminderSent: Scalars['Boolean']['output'];
  service: Service;
  startReminderAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: ServiceState;
  store: Store;
  stylist?: Maybe<Employee>;
};

export type ServiceExecutionBroadcast = {
  __typename?: 'ServiceExecutionBroadcast';
  operation: BroadcastOperation;
  serviceExecution: ServiceExecution;
};

/** The connection type for ServiceExecution. */
export type ServiceExecutionConnection = {
  __typename?: 'ServiceExecutionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ServiceExecutionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ServiceExecution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ServiceExecutionEdge = {
  __typename?: 'ServiceExecutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ServiceExecution>;
};

export enum ServiceState {
  /** Service is called */
  Called = 'CALLED',
  /** Service is canceled */
  Canceled = 'CANCELED',
  /** Service has ended */
  Ended = 'ENDED',
  /** Service is on hold */
  OnHold = 'ON_HOLD',
  /** Service is queued */
  Queued = 'QUEUED',
  /** Service has started */
  Started = 'STARTED'
}

/** Autogenerated input type of SnoozeReminder */
export type SnoozeReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SnoozeReminder. */
export type SnoozeReminderPayload = {
  __typename?: 'SnoozeReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

/** Autogenerated input type of StartBreak */
export type StartBreakInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartBreak. */
export type StartBreakPayload = {
  __typename?: 'StartBreakPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of StartService */
export type StartServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartService. */
export type StartServicePayload = {
  __typename?: 'StartServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

export type Store = {
  __typename?: 'Store';
  active: Scalars['Boolean']['output'];
  bookingsCount: Scalars['Int']['output'];
  businessHours: StoreBusinessHours;
  checkedInStylists: Array<Employee>;
  checkoutType: CheckoutEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  googleReviewUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: StoreLocation;
  name: Scalars['String']['output'];
  nextOpenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  openNow: Scalars['Boolean']['output'];
  promotionBadge: Attachment;
  promotionBadgeActive: Scalars['Boolean']['output'];
  promotionBadgeInfoscreen: Scalars['Boolean']['output'];
  service: Service;
  slotsAvailable: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitingTime: Scalars['Int']['output'];
};

export type StoreBusinessDay = {
  __typename?: 'StoreBusinessDay';
  closed: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type StoreBusinessHours = {
  __typename?: 'StoreBusinessHours';
  friday: StoreBusinessDay;
  /** Holidays for the store (only future holidays are returned) */
  holidays: Array<StoreHoliday>;
  monday: StoreBusinessDay;
  saturday: StoreBusinessDay;
  sunday: StoreBusinessDay;
  thursday: StoreBusinessDay;
  tuesday: StoreBusinessDay;
  wednesday: StoreBusinessDay;
};

/** The connection type for Store. */
export type StoreConnection = {
  __typename?: 'StoreConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Store>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StoreEdge = {
  __typename?: 'StoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Store>;
};

export type StoreHoliday = {
  __typename?: 'StoreHoliday';
  closed: Scalars['Boolean']['output'];
  date: Scalars['ISO8601Date']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type StoreLocation = {
  __typename?: 'StoreLocation';
  city: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** Autogenerated input type of StoreSignIn */
export type StoreSignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StoreSignIn. */
export type StoreSignInPayload = {
  __typename?: 'StoreSignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  store?: Maybe<Store>;
  token?: Maybe<Scalars['String']['output']>;
};

export type StylistBroadcast = {
  __typename?: 'StylistBroadcast';
  operation: BroadcastOperation;
  stylist: Employee;
};

export enum StylistState {
  /** On a break */
  Break = 'BREAK',
  /** Not in the salon */
  CheckedOut = 'CHECKED_OUT',
  /** Not working but available */
  Idle = 'IDLE',
  /** Waiting for a customer */
  WaitingCustomer = 'WAITING_CUSTOMER',
  /** Working on a haircut */
  Working = 'WORKING'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to changes in a booking. */
  bookingUpdate: Booking;
  /** Subscribe to changes in the pre bookings of a store. */
  preBookingUpdate: PreBookingBroadcast;
  /** Subscribe to changes in the service executions of a store. */
  serviceExecutionUpdate: ServiceExecutionBroadcast;
  /** Subscribe to changes in the store. */
  storeUpdate: Store;
  /** Subscribe to changes on employee checked in a store. */
  stylistUpdate: StylistBroadcast;
};


export type SubscriptionBookingUpdateArgs = {
  uid: Scalars['ID']['input'];
};


export type SubscriptionPreBookingUpdateArgs = {
  slug: Scalars['String']['input'];
};


export type SubscriptionServiceExecutionUpdateArgs = {
  slug: Scalars['String']['input'];
};


export type SubscriptionStoreUpdateArgs = {
  slug: Scalars['String']['input'];
};


export type SubscriptionStylistUpdateArgs = {
  slug: Scalars['String']['input'];
};

/** Autogenerated input type of UpdatePreferences */
export type UpdatePreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  data: CustomerPreferencesInput;
};

/** Autogenerated return type of UpdatePreferences. */
export type UpdatePreferencesPayload = {
  __typename?: 'UpdatePreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of UpdateSettings */
export type UpdateSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  data: CustomerSettingsInput;
};

/** Autogenerated return type of UpdateSettings. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidateCoupon */
export type ValidateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateCoupon. */
export type ValidateCouponPayload = {
  __typename?: 'ValidateCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidatePhoneCustomer */
export type ValidatePhoneCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidatePhoneCustomer. */
export type ValidatePhoneCustomerPayload = {
  __typename?: 'ValidatePhoneCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidatePhoneNumber */
export type ValidatePhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidatePhoneNumber. */
export type ValidatePhoneNumberPayload = {
  __typename?: 'ValidatePhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  valid: Scalars['Boolean']['output'];
};

export type BasicAttachmentFragment = { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null };

export type CompleteBookingFragment = { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null };

export type BasicBookingFragment = { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null };

export type BasicBreakFragment = { __typename?: 'BreakTime', id: string, duration: number, createdAt: any };

export type BasicCouponFragment = { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null };

export type ReferralCouponFragment = { __typename?: 'Coupon', code: string, type: string, expired: boolean, expiresAt?: any | null, customer?: { __typename?: 'Customer', name: string } | null };

export type BasicCustomerFragment = { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null };

export type ErrorFragment = { __typename?: 'RecordError', message: string, path?: Array<string> | null };

export type BasicLocationFragment = { __typename?: 'StoreLocation', city: string, street: string, zipCode: string };

export type BasicPassFragment = { __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string };

export type BasicPassPurchaseFragment = { __typename?: 'PassPurchase', id: string, uid: string, createdAt: any };

export type CompletePassPurchaseFragment = { __typename?: 'PassPurchase', id: string, uid: string, createdAt: any, pass: { __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null };

export type CompletePaymentTransactionFragment = { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null };

export type BasicPaymentTransactionFragment = { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number };

export type BasicPaymentTransactionDataFragment = { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null };

export type BasicPreBookingFragment = { __typename?: 'PreBooking', id: string, bookTime: any, uid: string };

export type CompletePreBookingFragment = { __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } };

export type PreBookingUpdateFragment = { __typename?: 'PreBookingBroadcast', operation: BroadcastOperation, preBooking: { __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } };

export type CompleteReviewFragment = { __typename?: 'Review', id: string, score: number, description?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } };

export type BasicReviewFragment = { __typename?: 'Review', id: string, score: number, description?: string | null };

export type BasicServiceFragment = { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null };

export type CompleteServiceExecutionFragment = { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } };

export type BasicServiceExecutionFragment = { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any };

export type ServiceExecutionUpdateFragment = { __typename?: 'ServiceExecutionBroadcast', operation: BroadcastOperation, serviceExecution: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } };

export type CompleteStoreFragment = { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, checkedInStylists: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean }>, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } };

export type BasicStoreFragment = { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } };

export type SimpleStoreFragment = { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, checkedInStylists: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean }>, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } };

export type BasicBusinessDayFragment = { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string };

export type BasicBusinessHoursFragment = { __typename?: 'StoreBusinessHours', monday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, tuesday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, wednesday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, thursday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, friday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, saturday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, sunday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, holidays: Array<{ __typename?: 'StoreHoliday', date: any, closed: boolean, startTime: string, endTime: string }> };

export type StoreHolidayFragment = { __typename?: 'StoreHoliday', date: any, closed: boolean, startTime: string, endTime: string };

export type CompleteStylistFragment = { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null };

export type BasicStylistFragment = { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean };

export type StylistUpdateFragment = { __typename?: 'StylistBroadcast', operation: BroadcastOperation, stylist: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } };

export type CallNextcustomerMutationVariables = Exact<{
  input: CallNextCustomerInput;
}>;


export type CallNextcustomerMutation = { __typename?: 'Mutation', callNextCustomer?: { __typename?: 'CallNextCustomerPayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CheckInMutationVariables = Exact<{
  input: CheckInInput;
}>;


export type CheckInMutation = { __typename?: 'Mutation', checkIn?: { __typename?: 'CheckInPayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CheckOutMutationVariables = Exact<{
  input: CheckOutInput;
}>;


export type CheckOutMutation = { __typename?: 'Mutation', checkOut?: { __typename?: 'CheckOutPayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type ConvertPreBookingMutationVariables = Exact<{
  input: ConvertPreBookingInput;
}>;


export type ConvertPreBookingMutation = { __typename?: 'Mutation', convertPreBooking?: { __typename?: 'ConvertPreBookingPayload', preBooking?: { __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'CreateBookingPayload', booking?: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreateBookingTransactionMutationVariables = Exact<{
  input: CreateBookingTransactionInput;
}>;


export type CreateBookingTransactionMutation = { __typename?: 'Mutation', createBookingTransaction?: { __typename?: 'CreateBookingTransactionPayload', paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreatePassPurchaseMutationVariables = Exact<{
  input: CreatePassPurchaseInput;
}>;


export type CreatePassPurchaseMutation = { __typename?: 'Mutation', createPassPurchase?: { __typename?: 'CreatePassPurchasePayload', passPurchase?: { __typename?: 'PassPurchase', id: string, uid: string, createdAt: any, pass: { __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreatePassTransactionMutationVariables = Exact<{
  input: CreatePassTransactionInput;
}>;


export type CreatePassTransactionMutation = { __typename?: 'Mutation', createPassTransaction?: { __typename?: 'CreatePassTransactionPayload', paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreatePreBookingMutationVariables = Exact<{
  input: CreatePreBookingInput;
}>;


export type CreatePreBookingMutation = { __typename?: 'Mutation', createPreBooking?: { __typename?: 'CreatePreBookingPayload', preBooking?: { __typename?: 'PreBooking', id: string, bookTime: any, uid: string } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreatePreBookingTransactionMutationVariables = Exact<{
  input: CreatePreBookingTransactionInput;
}>;


export type CreatePreBookingTransactionMutation = { __typename?: 'Mutation', createPreBookingTransaction?: { __typename?: 'CreatePreBookingTransactionPayload', paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type CreateReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview?: { __typename?: 'CreateReviewPayload', review?: { __typename?: 'Review', id: string, score: number, description?: string | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type EndBreakMutationVariables = Exact<{
  input: EndBreakInput;
}>;


export type EndBreakMutation = { __typename?: 'Mutation', endBreak?: { __typename?: 'EndBreakPayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type EndServiceMutationVariables = Exact<{
  input: EndServiceInput;
}>;


export type EndServiceMutation = { __typename?: 'Mutation', endService?: { __typename?: 'EndServicePayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type HoldServiceMutationVariables = Exact<{
  input: HoldServiceInput;
}>;


export type HoldServiceMutation = { __typename?: 'Mutation', holdService?: { __typename?: 'HoldServicePayload', serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type QueueServiceMutationVariables = Exact<{
  input: QueueServiceInput;
}>;


export type QueueServiceMutation = { __typename?: 'Mutation', queueService?: { __typename?: 'QueueServicePayload', serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type SnoozeReminderMutationVariables = Exact<{
  input: SnoozeReminderInput;
}>;


export type SnoozeReminderMutation = { __typename?: 'Mutation', snoozeReminder?: { __typename?: 'SnoozeReminderPayload', serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type StartBreakMutationVariables = Exact<{
  input: StartBreakInput;
}>;


export type StartBreakMutation = { __typename?: 'Mutation', startBreak?: { __typename?: 'StartBreakPayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type StartServiceMutationVariables = Exact<{
  input: StartServiceInput;
}>;


export type StartServiceMutation = { __typename?: 'Mutation', startService?: { __typename?: 'StartServicePayload', stylist?: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type StoreSignInMutationVariables = Exact<{
  input: StoreSignInInput;
}>;


export type StoreSignInMutation = { __typename?: 'Mutation', storeSignIn?: { __typename?: 'StoreSignInPayload', token?: string | null, store?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type UpdatePreferencesMutationVariables = Exact<{
  input: UpdatePreferencesInput;
}>;


export type UpdatePreferencesMutation = { __typename?: 'Mutation', updatePreferences?: { __typename?: 'UpdatePreferencesPayload', customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type UpdateSettingsMutationVariables = Exact<{
  input: UpdateSettingsInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings?: { __typename?: 'UpdateSettingsPayload', customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type ValidateCouponMutationVariables = Exact<{
  input: ValidateCouponInput;
}>;


export type ValidateCouponMutation = { __typename?: 'Mutation', validateCoupon?: { __typename?: 'ValidateCouponPayload', coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type ValidatePhoneCustomerMutationVariables = Exact<{
  input: ValidatePhoneCustomerInput;
}>;


export type ValidatePhoneCustomerMutation = { __typename?: 'Mutation', validatePhoneCustomer?: { __typename?: 'ValidatePhoneCustomerPayload', customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type ValidatePhoneNumberMutationVariables = Exact<{
  input: ValidatePhoneNumberInput;
}>;


export type ValidatePhoneNumberMutation = { __typename?: 'Mutation', validatePhoneNumber?: { __typename?: 'ValidatePhoneNumberPayload', valid: boolean, errors: Array<{ __typename?: 'RecordError', message: string, path?: Array<string> | null }> } | null };

export type GetBookingQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null } | null };

export type GetCheckedInStylistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckedInStylistsQuery = { __typename?: 'Query', checkedInStylists: { __typename?: 'EmployeeConnection', nodes?: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null> | null } };

export type GetCouponQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetCouponQuery = { __typename?: 'Query', coupon?: { __typename?: 'Coupon', code: string, type: string, expired: boolean, expiresAt?: any | null, customer?: { __typename?: 'Customer', name: string } | null } | null };

export type GetCustomerQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null };

export type GetPassQueryVariables = Exact<{
  passId: Scalars['ID']['input'];
}>;


export type GetPassQuery = { __typename?: 'Query', pass?: { __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string } | null };

export type GetPassPurchaseQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetPassPurchaseQuery = { __typename?: 'Query', passPurchase?: { __typename?: 'PassPurchase', id: string, uid: string, createdAt: any, pass: { __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number } | null } | null };

export type GetPassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPassesQuery = { __typename?: 'Query', passes: { __typename?: 'PassConnection', nodes?: Array<{ __typename?: 'Pass', id: string, title: string, price: number, maxUses: number, active: boolean, purchasesCount: number, basePrice: number, bookingsPaid: number, specialPromotion: boolean, subtitle?: string | null, timeToExpire: number, expireUnit: ExpireUnit, customColor: string } | null> | null } };

export type GetPaymentTransactionQueryVariables = Exact<{
  paymentTransactionId: Scalars['ID']['input'];
}>;


export type GetPaymentTransactionQuery = { __typename?: 'Query', paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null };

export type GetPreBookingQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetPreBookingQuery = { __typename?: 'Query', preBooking?: { __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null };

export type GetPreBookingsQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
}>;


export type GetPreBookingsQuery = { __typename?: 'Query', preBookings: { __typename?: 'PreBookingConnection', nodes?: Array<{ __typename?: 'PreBooking', id: string, bookTime: any, uid: string } | null> | null } };

export type GetServiceExecutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceExecutionsQuery = { __typename?: 'Query', serviceExecutions: { __typename?: 'ServiceExecutionConnection', nodes?: Array<{ __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null> | null } };

export type GetStoreQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetStoreQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, checkedInStylists: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean }>, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null };

export type GetBusinessHoursQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
}>;


export type GetBusinessHoursQuery = { __typename?: 'Query', businessHours: { __typename?: 'StoreBusinessHours', monday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, tuesday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, wednesday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, thursday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, friday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, saturday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, sunday: { __typename?: 'StoreBusinessDay', closed: boolean, startTime: string, endTime: string }, holidays: Array<{ __typename?: 'StoreHoliday', date: any, closed: boolean, startTime: string, endTime: string }> } };

export type GetStorePreBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStorePreBookingsQuery = { __typename?: 'Query', storePreBookings: { __typename?: 'PreBookingConnection', nodes?: Array<{ __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null> | null } };

export type GetStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoresQuery = { __typename?: 'Query', stores: { __typename?: 'StoreConnection', nodes?: Array<{ __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null> | null } };

export type GetStylistsQueryVariables = Exact<{
  onlyCheckedOut?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStylistsQuery = { __typename?: 'Query', stylists: { __typename?: 'EmployeeConnection', nodes?: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } | null> | null } };

export type BookingUpdateSubscriptionVariables = Exact<{
  uid: Scalars['ID']['input'];
}>;


export type BookingUpdateSubscription = { __typename?: 'Subscription', bookingUpdate: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null } };

export type PreBookingUpdateSubscriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PreBookingUpdateSubscription = { __typename?: 'Subscription', preBookingUpdate: { __typename?: 'PreBookingBroadcast', operation: BroadcastOperation, preBooking: { __typename?: 'PreBooking', id: string, bookTime: any, uid: string, store: { __typename?: 'Store', name: string }, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } } };

export type ServiceExecutionUpdateSubscriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ServiceExecutionUpdateSubscription = { __typename?: 'Subscription', serviceExecutionUpdate: { __typename?: 'ServiceExecutionBroadcast', operation: BroadcastOperation, serviceExecution: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } } };

export type StoreUpdateSubscriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StoreUpdateSubscription = { __typename?: 'Subscription', storeUpdate: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, checkedInStylists: Array<{ __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean }>, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } };

export type StylistUpdateSubscriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StylistUpdateSubscription = { __typename?: 'Subscription', stylistUpdate: { __typename?: 'StylistBroadcast', operation: BroadcastOperation, stylist: { __typename?: 'Employee', id: string, name: string, state: StylistState, active: boolean, currentBreak?: { __typename?: 'BreakTime', id: string, duration: number, createdAt: any } | null, currentServiceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any, stylist?: { __typename?: 'Employee', id: string, name: string } | null, booking: { __typename?: 'Booking', id: string, uid: string, bookingCode: string, manual: boolean, waitingTime: number, createdAt: any, customName?: string | null, store: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } }, paymentTransaction?: { __typename?: 'PaymentTransaction', id: string, datatransId?: string | null, reference: string, amount: number, data?: { __typename?: 'PaymentTransactionData', couponCode?: string | null, customerName: string, kidCustomer: boolean, manual: boolean, passGid?: string | null, phoneNumber: string, silentBooking?: boolean | null, storeSlug?: string | null } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null }, coupon?: { __typename?: 'Coupon', id: string, code: string, usesLeft: number, expired: boolean, price: number, bookingsCount: number, maxUses: number, expiresAt?: any | null } | null, customer: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null }, serviceExecution?: { __typename?: 'ServiceExecution', id: string, state: ServiceState, calledAt?: any | null, heldAt?: any | null, startedAt?: any | null, startReminderAt?: any | null, reminderSent: boolean, order?: number | null, projectedWaitingTime: number, projectedBookTime?: any | null, createdAt: any } | null }, customer?: { __typename?: 'Customer', id: string, code: string, name: string, phoneNumber: string, bookingsCount: number, lastBookingDate?: any | null, preferences: { __typename?: 'CustomerPreferences', submittedPreferences: boolean, hairLength?: HairLength | null, lengthSides?: number | null, lengthTop?: number | null, ears?: EarStyle | null, neckline?: Neckline | null, layers: boolean, backStyle?: BackStyle | null, parting?: Parting | null, cutEyebrows: boolean, notes?: string | null }, settings?: { __typename?: 'CustomerSettings', loyaltyMessages: boolean, serviceMessages: boolean, personalizedOffers: boolean } | null } | null, service: { __typename?: 'Service', id: string, price: number, kidsPrice?: number | null } } | null, lastActionStore?: { __typename?: 'Store', id: string, name: string, openNow: boolean, waitingTime: number, nextOpenAt?: any | null, slug: string, slotsAvailable: boolean, active: boolean, bookingsCount: number, googleReviewUrl?: string | null, promotionBadgeActive: boolean, promotionBadgeInfoscreen: boolean, checkoutType: CheckoutEnum, promotionBadge: { __typename?: 'Attachment', attached: boolean, contentType?: string | null, filename?: string | null, fileSize?: number | null, downloadLink?: string | null }, location: { __typename?: 'StoreLocation', city: string, street: string, zipCode: string } } | null, currentCheckIn?: { __typename?: 'CheckIn', id: string, startedAt: any } | null } } };

export const ReferralCouponFragmentDoc = gql`
    fragment ReferralCoupon on Coupon {
  code
  type
  expired
  expiresAt
  customer {
    name
  }
}
    `;
export const ErrorFragmentDoc = gql`
    fragment Error on RecordError {
  message
  path
}
    `;
export const BasicPassPurchaseFragmentDoc = gql`
    fragment BasicPassPurchase on PassPurchase {
  id
  uid
  createdAt
}
    `;
export const BasicPassFragmentDoc = gql`
    fragment BasicPass on Pass {
  id
  title
  price
  maxUses
  active
  purchasesCount
  basePrice
  bookingsPaid
  specialPromotion
  subtitle
  timeToExpire
  expireUnit
  customColor
}
    `;
export const BasicCustomerFragmentDoc = gql`
    fragment BasicCustomer on Customer {
  id
  code
  name
  phoneNumber
  bookingsCount
  lastBookingDate
  preferences {
    submittedPreferences
    hairLength
    lengthSides
    lengthTop
    ears
    neckline
    layers
    backStyle
    parting
    cutEyebrows
    notes
  }
  settings {
    loyaltyMessages
    serviceMessages
    personalizedOffers
  }
}
    `;
export const BasicCouponFragmentDoc = gql`
    fragment BasicCoupon on Coupon {
  id
  code
  usesLeft
  expired
  price
  bookingsCount
  maxUses
  expiresAt
}
    `;
export const BasicPaymentTransactionFragmentDoc = gql`
    fragment BasicPaymentTransaction on PaymentTransaction {
  id
  datatransId
  reference
  amount
}
    `;
export const CompletePassPurchaseFragmentDoc = gql`
    fragment CompletePassPurchase on PassPurchase {
  ...BasicPassPurchase
  pass {
    ...BasicPass
  }
  customer {
    ...BasicCustomer
  }
  coupon {
    ...BasicCoupon
  }
  paymentTransaction {
    ...BasicPaymentTransaction
  }
}
    ${BasicPassPurchaseFragmentDoc}
${BasicPassFragmentDoc}
${BasicCustomerFragmentDoc}
${BasicCouponFragmentDoc}
${BasicPaymentTransactionFragmentDoc}`;
export const BasicPreBookingFragmentDoc = gql`
    fragment BasicPreBooking on PreBooking {
  id
  bookTime
  uid
}
    `;
export const BasicServiceFragmentDoc = gql`
    fragment BasicService on Service {
  id
  price
  kidsPrice
}
    `;
export const CompletePreBookingFragmentDoc = gql`
    fragment CompletePreBooking on PreBooking {
  ...BasicPreBooking
  store {
    name
  }
  customer {
    ...BasicCustomer
  }
  service {
    ...BasicService
  }
}
    ${BasicPreBookingFragmentDoc}
${BasicCustomerFragmentDoc}
${BasicServiceFragmentDoc}`;
export const PreBookingUpdateFragmentDoc = gql`
    fragment PreBookingUpdate on PreBookingBroadcast {
  operation
  preBooking {
    ...CompletePreBooking
  }
}
    ${CompletePreBookingFragmentDoc}`;
export const BasicReviewFragmentDoc = gql`
    fragment BasicReview on Review {
  id
  score
  description
}
    `;
export const BasicAttachmentFragmentDoc = gql`
    fragment BasicAttachment on Attachment {
  attached
  contentType
  filename
  fileSize
  downloadLink
}
    `;
export const BasicLocationFragmentDoc = gql`
    fragment BasicLocation on StoreLocation {
  city
  street
  zipCode
}
    `;
export const BasicStoreFragmentDoc = gql`
    fragment BasicStore on Store {
  id
  name
  openNow
  waitingTime
  nextOpenAt
  slug
  slotsAvailable
  active
  bookingsCount
  googleReviewUrl
  promotionBadgeActive
  promotionBadgeInfoscreen
  checkoutType
  promotionBadge {
    ...BasicAttachment
  }
  location {
    ...BasicLocation
  }
}
    ${BasicAttachmentFragmentDoc}
${BasicLocationFragmentDoc}`;
export const BasicBookingFragmentDoc = gql`
    fragment BasicBooking on Booking {
  id
  uid
  bookingCode
  manual
  waitingTime
  createdAt
  customName
}
    `;
export const CompleteReviewFragmentDoc = gql`
    fragment CompleteReview on Review {
  ...BasicReview
  store {
    ...BasicStore
  }
  booking {
    ...BasicBooking
  }
  customer {
    ...BasicCustomer
  }
}
    ${BasicReviewFragmentDoc}
${BasicStoreFragmentDoc}
${BasicBookingFragmentDoc}
${BasicCustomerFragmentDoc}`;
export const BasicServiceExecutionFragmentDoc = gql`
    fragment BasicServiceExecution on ServiceExecution {
  id
  state
  calledAt
  heldAt
  startedAt
  startReminderAt
  reminderSent
  order
  projectedWaitingTime
  projectedBookTime
  createdAt
}
    `;
export const BasicPaymentTransactionDataFragmentDoc = gql`
    fragment BasicPaymentTransactionData on PaymentTransactionData {
  couponCode
  customerName
  kidCustomer
  manual
  passGid
  phoneNumber
  silentBooking
  storeSlug
}
    `;
export const CompletePaymentTransactionFragmentDoc = gql`
    fragment CompletePaymentTransaction on PaymentTransaction {
  ...BasicPaymentTransaction
  data {
    ...BasicPaymentTransactionData
  }
}
    ${BasicPaymentTransactionFragmentDoc}
${BasicPaymentTransactionDataFragmentDoc}`;
export const CompleteBookingFragmentDoc = gql`
    fragment CompleteBooking on Booking {
  ...BasicBooking
  store {
    ...BasicStore
  }
  paymentTransaction {
    ...CompletePaymentTransaction
  }
  service {
    ...BasicService
  }
  coupon {
    ...BasicCoupon
  }
  customer {
    ...BasicCustomer
  }
  serviceExecution {
    ...BasicServiceExecution
  }
}
    ${BasicBookingFragmentDoc}
${BasicStoreFragmentDoc}
${CompletePaymentTransactionFragmentDoc}
${BasicServiceFragmentDoc}
${BasicCouponFragmentDoc}
${BasicCustomerFragmentDoc}
${BasicServiceExecutionFragmentDoc}`;
export const CompleteServiceExecutionFragmentDoc = gql`
    fragment CompleteServiceExecution on ServiceExecution {
  ...BasicServiceExecution
  stylist {
    id
    name
  }
  booking {
    ...CompleteBooking
  }
  customer {
    ...BasicCustomer
  }
  service {
    ...BasicService
  }
}
    ${BasicServiceExecutionFragmentDoc}
${CompleteBookingFragmentDoc}
${BasicCustomerFragmentDoc}
${BasicServiceFragmentDoc}`;
export const ServiceExecutionUpdateFragmentDoc = gql`
    fragment ServiceExecutionUpdate on ServiceExecutionBroadcast {
  operation
  serviceExecution {
    ...CompleteServiceExecution
  }
}
    ${CompleteServiceExecutionFragmentDoc}`;
export const BasicStylistFragmentDoc = gql`
    fragment BasicStylist on Employee {
  id
  name
  state
  active
}
    `;
export const CompleteStoreFragmentDoc = gql`
    fragment CompleteStore on Store {
  ...BasicStore
  service {
    ...BasicService
  }
  checkedInStylists {
    ...BasicStylist
  }
}
    ${BasicStoreFragmentDoc}
${BasicServiceFragmentDoc}
${BasicStylistFragmentDoc}`;
export const SimpleStoreFragmentDoc = gql`
    fragment SimpleStore on Store {
  ...BasicStore
  checkedInStylists {
    ...BasicStylist
  }
}
    ${BasicStoreFragmentDoc}
${BasicStylistFragmentDoc}`;
export const BasicBusinessDayFragmentDoc = gql`
    fragment BasicBusinessDay on StoreBusinessDay {
  closed
  startTime
  endTime
}
    `;
export const StoreHolidayFragmentDoc = gql`
    fragment StoreHoliday on StoreHoliday {
  date
  closed
  startTime
  endTime
}
    `;
export const BasicBusinessHoursFragmentDoc = gql`
    fragment BasicBusinessHours on StoreBusinessHours {
  monday {
    ...BasicBusinessDay
  }
  tuesday {
    ...BasicBusinessDay
  }
  wednesday {
    ...BasicBusinessDay
  }
  thursday {
    ...BasicBusinessDay
  }
  friday {
    ...BasicBusinessDay
  }
  saturday {
    ...BasicBusinessDay
  }
  sunday {
    ...BasicBusinessDay
  }
  holidays {
    ...StoreHoliday
  }
}
    ${BasicBusinessDayFragmentDoc}
${StoreHolidayFragmentDoc}`;
export const BasicBreakFragmentDoc = gql`
    fragment BasicBreak on BreakTime {
  id
  duration
  createdAt
}
    `;
export const CompleteStylistFragmentDoc = gql`
    fragment CompleteStylist on Employee {
  ...BasicStylist
  currentBreak {
    ...BasicBreak
  }
  currentServiceExecution {
    ...CompleteServiceExecution
  }
  lastActionStore {
    ...BasicStore
  }
  currentCheckIn {
    id
    startedAt
  }
}
    ${BasicStylistFragmentDoc}
${BasicBreakFragmentDoc}
${CompleteServiceExecutionFragmentDoc}
${BasicStoreFragmentDoc}`;
export const StylistUpdateFragmentDoc = gql`
    fragment StylistUpdate on StylistBroadcast {
  operation
  stylist {
    ...CompleteStylist
  }
}
    ${CompleteStylistFragmentDoc}`;
export const CallNextcustomerDocument = gql`
    mutation callNextcustomer($input: CallNextCustomerInput!) {
  callNextCustomer(input: $input) {
    stylist {
      ...CompleteStylist
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteStylistFragmentDoc}
${ErrorFragmentDoc}`;
export type CallNextcustomerMutationFn = Apollo.MutationFunction<CallNextcustomerMutation, CallNextcustomerMutationVariables>;

/**
 * __useCallNextcustomerMutation__
 *
 * To run a mutation, you first call `useCallNextcustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallNextcustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callNextcustomerMutation, { data, loading, error }] = useCallNextcustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallNextcustomerMutation(baseOptions?: Apollo.MutationHookOptions<CallNextcustomerMutation, CallNextcustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallNextcustomerMutation, CallNextcustomerMutationVariables>(CallNextcustomerDocument, options);
      }
export type CallNextcustomerMutationHookResult = ReturnType<typeof useCallNextcustomerMutation>;
export type CallNextcustomerMutationResult = Apollo.MutationResult<CallNextcustomerMutation>;
export type CallNextcustomerMutationOptions = Apollo.BaseMutationOptions<CallNextcustomerMutation, CallNextcustomerMutationVariables>;
export const CheckInDocument = gql`
    mutation checkIn($input: CheckInInput!) {
  checkIn(input: $input) {
    stylist {
      ...BasicStylist
    }
    errors {
      ...Error
    }
  }
}
    ${BasicStylistFragmentDoc}
${ErrorFragmentDoc}`;
export type CheckInMutationFn = Apollo.MutationFunction<CheckInMutation, CheckInMutationVariables>;

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CheckInMutation, CheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(CheckInDocument, options);
      }
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>;
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>;
export type CheckInMutationOptions = Apollo.BaseMutationOptions<CheckInMutation, CheckInMutationVariables>;
export const CheckOutDocument = gql`
    mutation checkOut($input: CheckOutInput!) {
  checkOut(input: $input) {
    stylist {
      ...BasicStylist
    }
    errors {
      ...Error
    }
  }
}
    ${BasicStylistFragmentDoc}
${ErrorFragmentDoc}`;
export type CheckOutMutationFn = Apollo.MutationFunction<CheckOutMutation, CheckOutMutationVariables>;

/**
 * __useCheckOutMutation__
 *
 * To run a mutation, you first call `useCheckOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOutMutation, { data, loading, error }] = useCheckOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOutMutation(baseOptions?: Apollo.MutationHookOptions<CheckOutMutation, CheckOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckOutMutation, CheckOutMutationVariables>(CheckOutDocument, options);
      }
export type CheckOutMutationHookResult = ReturnType<typeof useCheckOutMutation>;
export type CheckOutMutationResult = Apollo.MutationResult<CheckOutMutation>;
export type CheckOutMutationOptions = Apollo.BaseMutationOptions<CheckOutMutation, CheckOutMutationVariables>;
export const ConvertPreBookingDocument = gql`
    mutation convertPreBooking($input: ConvertPreBookingInput!) {
  convertPreBooking(input: $input) {
    preBooking {
      ...CompletePreBooking
    }
    errors {
      ...Error
    }
  }
}
    ${CompletePreBookingFragmentDoc}
${ErrorFragmentDoc}`;
export type ConvertPreBookingMutationFn = Apollo.MutationFunction<ConvertPreBookingMutation, ConvertPreBookingMutationVariables>;

/**
 * __useConvertPreBookingMutation__
 *
 * To run a mutation, you first call `useConvertPreBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertPreBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertPreBookingMutation, { data, loading, error }] = useConvertPreBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertPreBookingMutation(baseOptions?: Apollo.MutationHookOptions<ConvertPreBookingMutation, ConvertPreBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertPreBookingMutation, ConvertPreBookingMutationVariables>(ConvertPreBookingDocument, options);
      }
export type ConvertPreBookingMutationHookResult = ReturnType<typeof useConvertPreBookingMutation>;
export type ConvertPreBookingMutationResult = Apollo.MutationResult<ConvertPreBookingMutation>;
export type ConvertPreBookingMutationOptions = Apollo.BaseMutationOptions<ConvertPreBookingMutation, ConvertPreBookingMutationVariables>;
export const CreateBookingDocument = gql`
    mutation createBooking($input: CreateBookingInput!) {
  createBooking(input: $input) {
    booking {
      ...BasicBooking
    }
    errors {
      ...Error
    }
  }
}
    ${BasicBookingFragmentDoc}
${ErrorFragmentDoc}`;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateBookingTransactionDocument = gql`
    mutation createBookingTransaction($input: CreateBookingTransactionInput!) {
  createBookingTransaction(input: $input) {
    paymentTransaction {
      ...BasicPaymentTransaction
    }
    errors {
      ...Error
    }
  }
}
    ${BasicPaymentTransactionFragmentDoc}
${ErrorFragmentDoc}`;
export type CreateBookingTransactionMutationFn = Apollo.MutationFunction<CreateBookingTransactionMutation, CreateBookingTransactionMutationVariables>;

/**
 * __useCreateBookingTransactionMutation__
 *
 * To run a mutation, you first call `useCreateBookingTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingTransactionMutation, { data, loading, error }] = useCreateBookingTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingTransactionMutation, CreateBookingTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingTransactionMutation, CreateBookingTransactionMutationVariables>(CreateBookingTransactionDocument, options);
      }
export type CreateBookingTransactionMutationHookResult = ReturnType<typeof useCreateBookingTransactionMutation>;
export type CreateBookingTransactionMutationResult = Apollo.MutationResult<CreateBookingTransactionMutation>;
export type CreateBookingTransactionMutationOptions = Apollo.BaseMutationOptions<CreateBookingTransactionMutation, CreateBookingTransactionMutationVariables>;
export const CreatePassPurchaseDocument = gql`
    mutation createPassPurchase($input: CreatePassPurchaseInput!) {
  createPassPurchase(input: $input) {
    passPurchase {
      ...CompletePassPurchase
    }
    errors {
      ...Error
    }
  }
}
    ${CompletePassPurchaseFragmentDoc}
${ErrorFragmentDoc}`;
export type CreatePassPurchaseMutationFn = Apollo.MutationFunction<CreatePassPurchaseMutation, CreatePassPurchaseMutationVariables>;

/**
 * __useCreatePassPurchaseMutation__
 *
 * To run a mutation, you first call `useCreatePassPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePassPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPassPurchaseMutation, { data, loading, error }] = useCreatePassPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePassPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreatePassPurchaseMutation, CreatePassPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePassPurchaseMutation, CreatePassPurchaseMutationVariables>(CreatePassPurchaseDocument, options);
      }
export type CreatePassPurchaseMutationHookResult = ReturnType<typeof useCreatePassPurchaseMutation>;
export type CreatePassPurchaseMutationResult = Apollo.MutationResult<CreatePassPurchaseMutation>;
export type CreatePassPurchaseMutationOptions = Apollo.BaseMutationOptions<CreatePassPurchaseMutation, CreatePassPurchaseMutationVariables>;
export const CreatePassTransactionDocument = gql`
    mutation createPassTransaction($input: CreatePassTransactionInput!) {
  createPassTransaction(input: $input) {
    paymentTransaction {
      ...BasicPaymentTransaction
    }
    errors {
      ...Error
    }
  }
}
    ${BasicPaymentTransactionFragmentDoc}
${ErrorFragmentDoc}`;
export type CreatePassTransactionMutationFn = Apollo.MutationFunction<CreatePassTransactionMutation, CreatePassTransactionMutationVariables>;

/**
 * __useCreatePassTransactionMutation__
 *
 * To run a mutation, you first call `useCreatePassTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePassTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPassTransactionMutation, { data, loading, error }] = useCreatePassTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePassTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePassTransactionMutation, CreatePassTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePassTransactionMutation, CreatePassTransactionMutationVariables>(CreatePassTransactionDocument, options);
      }
export type CreatePassTransactionMutationHookResult = ReturnType<typeof useCreatePassTransactionMutation>;
export type CreatePassTransactionMutationResult = Apollo.MutationResult<CreatePassTransactionMutation>;
export type CreatePassTransactionMutationOptions = Apollo.BaseMutationOptions<CreatePassTransactionMutation, CreatePassTransactionMutationVariables>;
export const CreatePreBookingDocument = gql`
    mutation createPreBooking($input: CreatePreBookingInput!) {
  createPreBooking(input: $input) {
    preBooking {
      ...BasicPreBooking
    }
    errors {
      ...Error
    }
  }
}
    ${BasicPreBookingFragmentDoc}
${ErrorFragmentDoc}`;
export type CreatePreBookingMutationFn = Apollo.MutationFunction<CreatePreBookingMutation, CreatePreBookingMutationVariables>;

/**
 * __useCreatePreBookingMutation__
 *
 * To run a mutation, you first call `useCreatePreBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreBookingMutation, { data, loading, error }] = useCreatePreBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreBookingMutation, CreatePreBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreBookingMutation, CreatePreBookingMutationVariables>(CreatePreBookingDocument, options);
      }
export type CreatePreBookingMutationHookResult = ReturnType<typeof useCreatePreBookingMutation>;
export type CreatePreBookingMutationResult = Apollo.MutationResult<CreatePreBookingMutation>;
export type CreatePreBookingMutationOptions = Apollo.BaseMutationOptions<CreatePreBookingMutation, CreatePreBookingMutationVariables>;
export const CreatePreBookingTransactionDocument = gql`
    mutation createPreBookingTransaction($input: CreatePreBookingTransactionInput!) {
  createPreBookingTransaction(input: $input) {
    paymentTransaction {
      ...BasicPaymentTransaction
    }
    errors {
      ...Error
    }
  }
}
    ${BasicPaymentTransactionFragmentDoc}
${ErrorFragmentDoc}`;
export type CreatePreBookingTransactionMutationFn = Apollo.MutationFunction<CreatePreBookingTransactionMutation, CreatePreBookingTransactionMutationVariables>;

/**
 * __useCreatePreBookingTransactionMutation__
 *
 * To run a mutation, you first call `useCreatePreBookingTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreBookingTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreBookingTransactionMutation, { data, loading, error }] = useCreatePreBookingTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreBookingTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreBookingTransactionMutation, CreatePreBookingTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreBookingTransactionMutation, CreatePreBookingTransactionMutationVariables>(CreatePreBookingTransactionDocument, options);
      }
export type CreatePreBookingTransactionMutationHookResult = ReturnType<typeof useCreatePreBookingTransactionMutation>;
export type CreatePreBookingTransactionMutationResult = Apollo.MutationResult<CreatePreBookingTransactionMutation>;
export type CreatePreBookingTransactionMutationOptions = Apollo.BaseMutationOptions<CreatePreBookingTransactionMutation, CreatePreBookingTransactionMutationVariables>;
export const CreateReviewDocument = gql`
    mutation createReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    review {
      ...BasicReview
    }
    errors {
      ...Error
    }
  }
}
    ${BasicReviewFragmentDoc}
${ErrorFragmentDoc}`;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const EndBreakDocument = gql`
    mutation endBreak($input: EndBreakInput!) {
  endBreak(input: $input) {
    stylist {
      ...CompleteStylist
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteStylistFragmentDoc}
${ErrorFragmentDoc}`;
export type EndBreakMutationFn = Apollo.MutationFunction<EndBreakMutation, EndBreakMutationVariables>;

/**
 * __useEndBreakMutation__
 *
 * To run a mutation, you first call `useEndBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endBreakMutation, { data, loading, error }] = useEndBreakMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndBreakMutation(baseOptions?: Apollo.MutationHookOptions<EndBreakMutation, EndBreakMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndBreakMutation, EndBreakMutationVariables>(EndBreakDocument, options);
      }
export type EndBreakMutationHookResult = ReturnType<typeof useEndBreakMutation>;
export type EndBreakMutationResult = Apollo.MutationResult<EndBreakMutation>;
export type EndBreakMutationOptions = Apollo.BaseMutationOptions<EndBreakMutation, EndBreakMutationVariables>;
export const EndServiceDocument = gql`
    mutation endService($input: EndServiceInput!) {
  endService(input: $input) {
    stylist {
      ...CompleteStylist
    }
    serviceExecution {
      ...CompleteServiceExecution
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteStylistFragmentDoc}
${CompleteServiceExecutionFragmentDoc}
${ErrorFragmentDoc}`;
export type EndServiceMutationFn = Apollo.MutationFunction<EndServiceMutation, EndServiceMutationVariables>;

/**
 * __useEndServiceMutation__
 *
 * To run a mutation, you first call `useEndServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endServiceMutation, { data, loading, error }] = useEndServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndServiceMutation(baseOptions?: Apollo.MutationHookOptions<EndServiceMutation, EndServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndServiceMutation, EndServiceMutationVariables>(EndServiceDocument, options);
      }
export type EndServiceMutationHookResult = ReturnType<typeof useEndServiceMutation>;
export type EndServiceMutationResult = Apollo.MutationResult<EndServiceMutation>;
export type EndServiceMutationOptions = Apollo.BaseMutationOptions<EndServiceMutation, EndServiceMutationVariables>;
export const HoldServiceDocument = gql`
    mutation holdService($input: HoldServiceInput!) {
  holdService(input: $input) {
    serviceExecution {
      ...BasicServiceExecution
    }
    errors {
      ...Error
    }
  }
}
    ${BasicServiceExecutionFragmentDoc}
${ErrorFragmentDoc}`;
export type HoldServiceMutationFn = Apollo.MutationFunction<HoldServiceMutation, HoldServiceMutationVariables>;

/**
 * __useHoldServiceMutation__
 *
 * To run a mutation, you first call `useHoldServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdServiceMutation, { data, loading, error }] = useHoldServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHoldServiceMutation(baseOptions?: Apollo.MutationHookOptions<HoldServiceMutation, HoldServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HoldServiceMutation, HoldServiceMutationVariables>(HoldServiceDocument, options);
      }
export type HoldServiceMutationHookResult = ReturnType<typeof useHoldServiceMutation>;
export type HoldServiceMutationResult = Apollo.MutationResult<HoldServiceMutation>;
export type HoldServiceMutationOptions = Apollo.BaseMutationOptions<HoldServiceMutation, HoldServiceMutationVariables>;
export const QueueServiceDocument = gql`
    mutation queueService($input: QueueServiceInput!) {
  queueService(input: $input) {
    serviceExecution {
      ...CompleteServiceExecution
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteServiceExecutionFragmentDoc}
${ErrorFragmentDoc}`;
export type QueueServiceMutationFn = Apollo.MutationFunction<QueueServiceMutation, QueueServiceMutationVariables>;

/**
 * __useQueueServiceMutation__
 *
 * To run a mutation, you first call `useQueueServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueServiceMutation, { data, loading, error }] = useQueueServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueServiceMutation(baseOptions?: Apollo.MutationHookOptions<QueueServiceMutation, QueueServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueServiceMutation, QueueServiceMutationVariables>(QueueServiceDocument, options);
      }
export type QueueServiceMutationHookResult = ReturnType<typeof useQueueServiceMutation>;
export type QueueServiceMutationResult = Apollo.MutationResult<QueueServiceMutation>;
export type QueueServiceMutationOptions = Apollo.BaseMutationOptions<QueueServiceMutation, QueueServiceMutationVariables>;
export const SnoozeReminderDocument = gql`
    mutation snoozeReminder($input: SnoozeReminderInput!) {
  snoozeReminder(input: $input) {
    serviceExecution {
      ...BasicServiceExecution
    }
    errors {
      ...Error
    }
  }
}
    ${BasicServiceExecutionFragmentDoc}
${ErrorFragmentDoc}`;
export type SnoozeReminderMutationFn = Apollo.MutationFunction<SnoozeReminderMutation, SnoozeReminderMutationVariables>;

/**
 * __useSnoozeReminderMutation__
 *
 * To run a mutation, you first call `useSnoozeReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeReminderMutation, { data, loading, error }] = useSnoozeReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeReminderMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeReminderMutation, SnoozeReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeReminderMutation, SnoozeReminderMutationVariables>(SnoozeReminderDocument, options);
      }
export type SnoozeReminderMutationHookResult = ReturnType<typeof useSnoozeReminderMutation>;
export type SnoozeReminderMutationResult = Apollo.MutationResult<SnoozeReminderMutation>;
export type SnoozeReminderMutationOptions = Apollo.BaseMutationOptions<SnoozeReminderMutation, SnoozeReminderMutationVariables>;
export const StartBreakDocument = gql`
    mutation startBreak($input: StartBreakInput!) {
  startBreak(input: $input) {
    stylist {
      ...CompleteStylist
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteStylistFragmentDoc}
${ErrorFragmentDoc}`;
export type StartBreakMutationFn = Apollo.MutationFunction<StartBreakMutation, StartBreakMutationVariables>;

/**
 * __useStartBreakMutation__
 *
 * To run a mutation, you first call `useStartBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBreakMutation, { data, loading, error }] = useStartBreakMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartBreakMutation(baseOptions?: Apollo.MutationHookOptions<StartBreakMutation, StartBreakMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBreakMutation, StartBreakMutationVariables>(StartBreakDocument, options);
      }
export type StartBreakMutationHookResult = ReturnType<typeof useStartBreakMutation>;
export type StartBreakMutationResult = Apollo.MutationResult<StartBreakMutation>;
export type StartBreakMutationOptions = Apollo.BaseMutationOptions<StartBreakMutation, StartBreakMutationVariables>;
export const StartServiceDocument = gql`
    mutation startService($input: StartServiceInput!) {
  startService(input: $input) {
    stylist {
      ...CompleteStylist
    }
    serviceExecution {
      ...CompleteServiceExecution
    }
    errors {
      ...Error
    }
  }
}
    ${CompleteStylistFragmentDoc}
${CompleteServiceExecutionFragmentDoc}
${ErrorFragmentDoc}`;
export type StartServiceMutationFn = Apollo.MutationFunction<StartServiceMutation, StartServiceMutationVariables>;

/**
 * __useStartServiceMutation__
 *
 * To run a mutation, you first call `useStartServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startServiceMutation, { data, loading, error }] = useStartServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartServiceMutation(baseOptions?: Apollo.MutationHookOptions<StartServiceMutation, StartServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartServiceMutation, StartServiceMutationVariables>(StartServiceDocument, options);
      }
export type StartServiceMutationHookResult = ReturnType<typeof useStartServiceMutation>;
export type StartServiceMutationResult = Apollo.MutationResult<StartServiceMutation>;
export type StartServiceMutationOptions = Apollo.BaseMutationOptions<StartServiceMutation, StartServiceMutationVariables>;
export const StoreSignInDocument = gql`
    mutation storeSignIn($input: StoreSignInInput!) {
  storeSignIn(input: $input) {
    token
    store {
      ...BasicStore
    }
    errors {
      ...Error
    }
  }
}
    ${BasicStoreFragmentDoc}
${ErrorFragmentDoc}`;
export type StoreSignInMutationFn = Apollo.MutationFunction<StoreSignInMutation, StoreSignInMutationVariables>;

/**
 * __useStoreSignInMutation__
 *
 * To run a mutation, you first call `useStoreSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSignInMutation, { data, loading, error }] = useStoreSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreSignInMutation(baseOptions?: Apollo.MutationHookOptions<StoreSignInMutation, StoreSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreSignInMutation, StoreSignInMutationVariables>(StoreSignInDocument, options);
      }
export type StoreSignInMutationHookResult = ReturnType<typeof useStoreSignInMutation>;
export type StoreSignInMutationResult = Apollo.MutationResult<StoreSignInMutation>;
export type StoreSignInMutationOptions = Apollo.BaseMutationOptions<StoreSignInMutation, StoreSignInMutationVariables>;
export const UpdatePreferencesDocument = gql`
    mutation updatePreferences($input: UpdatePreferencesInput!) {
  updatePreferences(input: $input) {
    customer {
      ...BasicCustomer
    }
    errors {
      ...Error
    }
  }
}
    ${BasicCustomerFragmentDoc}
${ErrorFragmentDoc}`;
export type UpdatePreferencesMutationFn = Apollo.MutationFunction<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;

/**
 * __useUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferencesMutation, { data, loading, error }] = useUpdatePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>(UpdatePreferencesDocument, options);
      }
export type UpdatePreferencesMutationHookResult = ReturnType<typeof useUpdatePreferencesMutation>;
export type UpdatePreferencesMutationResult = Apollo.MutationResult<UpdatePreferencesMutation>;
export type UpdatePreferencesMutationOptions = Apollo.BaseMutationOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation updateSettings($input: UpdateSettingsInput!) {
  updateSettings(input: $input) {
    customer {
      ...BasicCustomer
    }
    errors {
      ...Error
    }
  }
}
    ${BasicCustomerFragmentDoc}
${ErrorFragmentDoc}`;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const ValidateCouponDocument = gql`
    mutation validateCoupon($input: ValidateCouponInput!) {
  validateCoupon(input: $input) {
    coupon {
      ...BasicCoupon
    }
    errors {
      ...Error
    }
  }
}
    ${BasicCouponFragmentDoc}
${ErrorFragmentDoc}`;
export type ValidateCouponMutationFn = Apollo.MutationFunction<ValidateCouponMutation, ValidateCouponMutationVariables>;

/**
 * __useValidateCouponMutation__
 *
 * To run a mutation, you first call `useValidateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCouponMutation, { data, loading, error }] = useValidateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateCouponMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCouponMutation, ValidateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCouponMutation, ValidateCouponMutationVariables>(ValidateCouponDocument, options);
      }
export type ValidateCouponMutationHookResult = ReturnType<typeof useValidateCouponMutation>;
export type ValidateCouponMutationResult = Apollo.MutationResult<ValidateCouponMutation>;
export type ValidateCouponMutationOptions = Apollo.BaseMutationOptions<ValidateCouponMutation, ValidateCouponMutationVariables>;
export const ValidatePhoneCustomerDocument = gql`
    mutation validatePhoneCustomer($input: ValidatePhoneCustomerInput!) {
  validatePhoneCustomer(input: $input) {
    customer {
      ...BasicCustomer
    }
    errors {
      ...Error
    }
  }
}
    ${BasicCustomerFragmentDoc}
${ErrorFragmentDoc}`;
export type ValidatePhoneCustomerMutationFn = Apollo.MutationFunction<ValidatePhoneCustomerMutation, ValidatePhoneCustomerMutationVariables>;

/**
 * __useValidatePhoneCustomerMutation__
 *
 * To run a mutation, you first call `useValidatePhoneCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePhoneCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePhoneCustomerMutation, { data, loading, error }] = useValidatePhoneCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePhoneCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePhoneCustomerMutation, ValidatePhoneCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePhoneCustomerMutation, ValidatePhoneCustomerMutationVariables>(ValidatePhoneCustomerDocument, options);
      }
export type ValidatePhoneCustomerMutationHookResult = ReturnType<typeof useValidatePhoneCustomerMutation>;
export type ValidatePhoneCustomerMutationResult = Apollo.MutationResult<ValidatePhoneCustomerMutation>;
export type ValidatePhoneCustomerMutationOptions = Apollo.BaseMutationOptions<ValidatePhoneCustomerMutation, ValidatePhoneCustomerMutationVariables>;
export const ValidatePhoneNumberDocument = gql`
    mutation validatePhoneNumber($input: ValidatePhoneNumberInput!) {
  validatePhoneNumber(input: $input) {
    valid
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ValidatePhoneNumberMutationFn = Apollo.MutationFunction<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>;

/**
 * __useValidatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useValidatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePhoneNumberMutation, { data, loading, error }] = useValidatePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>(ValidatePhoneNumberDocument, options);
      }
export type ValidatePhoneNumberMutationHookResult = ReturnType<typeof useValidatePhoneNumberMutation>;
export type ValidatePhoneNumberMutationResult = Apollo.MutationResult<ValidatePhoneNumberMutation>;
export type ValidatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>;
export const GetBookingDocument = gql`
    query getBooking($uid: String!) {
  booking(uid: $uid) {
    ...CompleteBooking
  }
}
    ${CompleteBookingFragmentDoc}`;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables> & ({ variables: GetBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export function useGetBookingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingSuspenseQueryHookResult = ReturnType<typeof useGetBookingSuspenseQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const GetCheckedInStylistsDocument = gql`
    query getCheckedInStylists {
  checkedInStylists {
    nodes {
      ...CompleteStylist
    }
  }
}
    ${CompleteStylistFragmentDoc}`;

/**
 * __useGetCheckedInStylistsQuery__
 *
 * To run a query within a React component, call `useGetCheckedInStylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckedInStylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckedInStylistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCheckedInStylistsQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>(GetCheckedInStylistsDocument, options);
      }
export function useGetCheckedInStylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>(GetCheckedInStylistsDocument, options);
        }
export function useGetCheckedInStylistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>(GetCheckedInStylistsDocument, options);
        }
export type GetCheckedInStylistsQueryHookResult = ReturnType<typeof useGetCheckedInStylistsQuery>;
export type GetCheckedInStylistsLazyQueryHookResult = ReturnType<typeof useGetCheckedInStylistsLazyQuery>;
export type GetCheckedInStylistsSuspenseQueryHookResult = ReturnType<typeof useGetCheckedInStylistsSuspenseQuery>;
export type GetCheckedInStylistsQueryResult = Apollo.QueryResult<GetCheckedInStylistsQuery, GetCheckedInStylistsQueryVariables>;
export const GetCouponDocument = gql`
    query getCoupon($code: String!) {
  coupon(code: $code) {
    ...ReferralCoupon
  }
}
    ${ReferralCouponFragmentDoc}`;

/**
 * __useGetCouponQuery__
 *
 * To run a query within a React component, call `useGetCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCouponQuery(baseOptions: Apollo.QueryHookOptions<GetCouponQuery, GetCouponQueryVariables> & ({ variables: GetCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
      }
export function useGetCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export function useGetCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export type GetCouponQueryHookResult = ReturnType<typeof useGetCouponQuery>;
export type GetCouponLazyQueryHookResult = ReturnType<typeof useGetCouponLazyQuery>;
export type GetCouponSuspenseQueryHookResult = ReturnType<typeof useGetCouponSuspenseQuery>;
export type GetCouponQueryResult = Apollo.QueryResult<GetCouponQuery, GetCouponQueryVariables>;
export const GetCustomerDocument = gql`
    query getCustomer($code: String!) {
  customer(code: $code) {
    ...BasicCustomer
  }
}
    ${BasicCustomerFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetPassDocument = gql`
    query getPass($passId: ID!) {
  pass(passId: $passId) {
    ...BasicPass
  }
}
    ${BasicPassFragmentDoc}`;

/**
 * __useGetPassQuery__
 *
 * To run a query within a React component, call `useGetPassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassQuery({
 *   variables: {
 *      passId: // value for 'passId'
 *   },
 * });
 */
export function useGetPassQuery(baseOptions: Apollo.QueryHookOptions<GetPassQuery, GetPassQueryVariables> & ({ variables: GetPassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPassQuery, GetPassQueryVariables>(GetPassDocument, options);
      }
export function useGetPassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPassQuery, GetPassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPassQuery, GetPassQueryVariables>(GetPassDocument, options);
        }
export function useGetPassSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPassQuery, GetPassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPassQuery, GetPassQueryVariables>(GetPassDocument, options);
        }
export type GetPassQueryHookResult = ReturnType<typeof useGetPassQuery>;
export type GetPassLazyQueryHookResult = ReturnType<typeof useGetPassLazyQuery>;
export type GetPassSuspenseQueryHookResult = ReturnType<typeof useGetPassSuspenseQuery>;
export type GetPassQueryResult = Apollo.QueryResult<GetPassQuery, GetPassQueryVariables>;
export const GetPassPurchaseDocument = gql`
    query getPassPurchase($uid: String!) {
  passPurchase(uid: $uid) {
    ...CompletePassPurchase
  }
}
    ${CompletePassPurchaseFragmentDoc}`;

/**
 * __useGetPassPurchaseQuery__
 *
 * To run a query within a React component, call `useGetPassPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassPurchaseQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPassPurchaseQuery(baseOptions: Apollo.QueryHookOptions<GetPassPurchaseQuery, GetPassPurchaseQueryVariables> & ({ variables: GetPassPurchaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>(GetPassPurchaseDocument, options);
      }
export function useGetPassPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>(GetPassPurchaseDocument, options);
        }
export function useGetPassPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>(GetPassPurchaseDocument, options);
        }
export type GetPassPurchaseQueryHookResult = ReturnType<typeof useGetPassPurchaseQuery>;
export type GetPassPurchaseLazyQueryHookResult = ReturnType<typeof useGetPassPurchaseLazyQuery>;
export type GetPassPurchaseSuspenseQueryHookResult = ReturnType<typeof useGetPassPurchaseSuspenseQuery>;
export type GetPassPurchaseQueryResult = Apollo.QueryResult<GetPassPurchaseQuery, GetPassPurchaseQueryVariables>;
export const GetPassesDocument = gql`
    query getPasses {
  passes {
    nodes {
      ...BasicPass
    }
  }
}
    ${BasicPassFragmentDoc}`;

/**
 * __useGetPassesQuery__
 *
 * To run a query within a React component, call `useGetPassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPassesQuery(baseOptions?: Apollo.QueryHookOptions<GetPassesQuery, GetPassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPassesQuery, GetPassesQueryVariables>(GetPassesDocument, options);
      }
export function useGetPassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPassesQuery, GetPassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPassesQuery, GetPassesQueryVariables>(GetPassesDocument, options);
        }
export function useGetPassesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPassesQuery, GetPassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPassesQuery, GetPassesQueryVariables>(GetPassesDocument, options);
        }
export type GetPassesQueryHookResult = ReturnType<typeof useGetPassesQuery>;
export type GetPassesLazyQueryHookResult = ReturnType<typeof useGetPassesLazyQuery>;
export type GetPassesSuspenseQueryHookResult = ReturnType<typeof useGetPassesSuspenseQuery>;
export type GetPassesQueryResult = Apollo.QueryResult<GetPassesQuery, GetPassesQueryVariables>;
export const GetPaymentTransactionDocument = gql`
    query getPaymentTransaction($paymentTransactionId: ID!) {
  paymentTransaction(paymentTransactionId: $paymentTransactionId) {
    ...CompletePaymentTransaction
  }
}
    ${CompletePaymentTransactionFragmentDoc}`;

/**
 * __useGetPaymentTransactionQuery__
 *
 * To run a query within a React component, call `useGetPaymentTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTransactionQuery({
 *   variables: {
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *   },
 * });
 */
export function useGetPaymentTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables> & ({ variables: GetPaymentTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
      }
export function useGetPaymentTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
        }
export function useGetPaymentTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>(GetPaymentTransactionDocument, options);
        }
export type GetPaymentTransactionQueryHookResult = ReturnType<typeof useGetPaymentTransactionQuery>;
export type GetPaymentTransactionLazyQueryHookResult = ReturnType<typeof useGetPaymentTransactionLazyQuery>;
export type GetPaymentTransactionSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTransactionSuspenseQuery>;
export type GetPaymentTransactionQueryResult = Apollo.QueryResult<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>;
export const GetPreBookingDocument = gql`
    query getPreBooking($uid: String!) {
  preBooking(uid: $uid) {
    ...CompletePreBooking
  }
}
    ${CompletePreBookingFragmentDoc}`;

/**
 * __useGetPreBookingQuery__
 *
 * To run a query within a React component, call `useGetPreBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreBookingQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPreBookingQuery(baseOptions: Apollo.QueryHookOptions<GetPreBookingQuery, GetPreBookingQueryVariables> & ({ variables: GetPreBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreBookingQuery, GetPreBookingQueryVariables>(GetPreBookingDocument, options);
      }
export function useGetPreBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreBookingQuery, GetPreBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreBookingQuery, GetPreBookingQueryVariables>(GetPreBookingDocument, options);
        }
export function useGetPreBookingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreBookingQuery, GetPreBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreBookingQuery, GetPreBookingQueryVariables>(GetPreBookingDocument, options);
        }
export type GetPreBookingQueryHookResult = ReturnType<typeof useGetPreBookingQuery>;
export type GetPreBookingLazyQueryHookResult = ReturnType<typeof useGetPreBookingLazyQuery>;
export type GetPreBookingSuspenseQueryHookResult = ReturnType<typeof useGetPreBookingSuspenseQuery>;
export type GetPreBookingQueryResult = Apollo.QueryResult<GetPreBookingQuery, GetPreBookingQueryVariables>;
export const GetPreBookingsDocument = gql`
    query getPreBookings($storeId: ID!) {
  preBookings(storeId: $storeId) {
    nodes {
      ...BasicPreBooking
    }
  }
}
    ${BasicPreBookingFragmentDoc}`;

/**
 * __useGetPreBookingsQuery__
 *
 * To run a query within a React component, call `useGetPreBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreBookingsQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetPreBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetPreBookingsQuery, GetPreBookingsQueryVariables> & ({ variables: GetPreBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreBookingsQuery, GetPreBookingsQueryVariables>(GetPreBookingsDocument, options);
      }
export function useGetPreBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreBookingsQuery, GetPreBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreBookingsQuery, GetPreBookingsQueryVariables>(GetPreBookingsDocument, options);
        }
export function useGetPreBookingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreBookingsQuery, GetPreBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreBookingsQuery, GetPreBookingsQueryVariables>(GetPreBookingsDocument, options);
        }
export type GetPreBookingsQueryHookResult = ReturnType<typeof useGetPreBookingsQuery>;
export type GetPreBookingsLazyQueryHookResult = ReturnType<typeof useGetPreBookingsLazyQuery>;
export type GetPreBookingsSuspenseQueryHookResult = ReturnType<typeof useGetPreBookingsSuspenseQuery>;
export type GetPreBookingsQueryResult = Apollo.QueryResult<GetPreBookingsQuery, GetPreBookingsQueryVariables>;
export const GetServiceExecutionsDocument = gql`
    query getServiceExecutions {
  serviceExecutions {
    nodes {
      ...CompleteServiceExecution
    }
  }
}
    ${CompleteServiceExecutionFragmentDoc}`;

/**
 * __useGetServiceExecutionsQuery__
 *
 * To run a query within a React component, call `useGetServiceExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceExecutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>(GetServiceExecutionsDocument, options);
      }
export function useGetServiceExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>(GetServiceExecutionsDocument, options);
        }
export function useGetServiceExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>(GetServiceExecutionsDocument, options);
        }
export type GetServiceExecutionsQueryHookResult = ReturnType<typeof useGetServiceExecutionsQuery>;
export type GetServiceExecutionsLazyQueryHookResult = ReturnType<typeof useGetServiceExecutionsLazyQuery>;
export type GetServiceExecutionsSuspenseQueryHookResult = ReturnType<typeof useGetServiceExecutionsSuspenseQuery>;
export type GetServiceExecutionsQueryResult = Apollo.QueryResult<GetServiceExecutionsQuery, GetServiceExecutionsQueryVariables>;
export const GetStoreDocument = gql`
    query getStore($slug: String!) {
  store(slug: $slug) {
    ...CompleteStore
  }
}
    ${CompleteStoreFragmentDoc}`;

/**
 * __useGetStoreQuery__
 *
 * To run a query within a React component, call `useGetStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetStoreQuery(baseOptions: Apollo.QueryHookOptions<GetStoreQuery, GetStoreQueryVariables> & ({ variables: GetStoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
      }
export function useGetStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreQuery, GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
        }
export function useGetStoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoreQuery, GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
        }
export type GetStoreQueryHookResult = ReturnType<typeof useGetStoreQuery>;
export type GetStoreLazyQueryHookResult = ReturnType<typeof useGetStoreLazyQuery>;
export type GetStoreSuspenseQueryHookResult = ReturnType<typeof useGetStoreSuspenseQuery>;
export type GetStoreQueryResult = Apollo.QueryResult<GetStoreQuery, GetStoreQueryVariables>;
export const GetBusinessHoursDocument = gql`
    query getBusinessHours($storeId: ID!) {
  businessHours(storeId: $storeId) {
    monday {
      ...BasicBusinessDay
    }
    tuesday {
      ...BasicBusinessDay
    }
    wednesday {
      ...BasicBusinessDay
    }
    thursday {
      ...BasicBusinessDay
    }
    friday {
      ...BasicBusinessDay
    }
    saturday {
      ...BasicBusinessDay
    }
    sunday {
      ...BasicBusinessDay
    }
    holidays {
      ...StoreHoliday
    }
  }
}
    ${BasicBusinessDayFragmentDoc}
${StoreHolidayFragmentDoc}`;

/**
 * __useGetBusinessHoursQuery__
 *
 * To run a query within a React component, call `useGetBusinessHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessHoursQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useGetBusinessHoursQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessHoursQuery, GetBusinessHoursQueryVariables> & ({ variables: GetBusinessHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>(GetBusinessHoursDocument, options);
      }
export function useGetBusinessHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>(GetBusinessHoursDocument, options);
        }
export function useGetBusinessHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>(GetBusinessHoursDocument, options);
        }
export type GetBusinessHoursQueryHookResult = ReturnType<typeof useGetBusinessHoursQuery>;
export type GetBusinessHoursLazyQueryHookResult = ReturnType<typeof useGetBusinessHoursLazyQuery>;
export type GetBusinessHoursSuspenseQueryHookResult = ReturnType<typeof useGetBusinessHoursSuspenseQuery>;
export type GetBusinessHoursQueryResult = Apollo.QueryResult<GetBusinessHoursQuery, GetBusinessHoursQueryVariables>;
export const GetStorePreBookingsDocument = gql`
    query getStorePreBookings {
  storePreBookings {
    nodes {
      ...CompletePreBooking
    }
  }
}
    ${CompletePreBookingFragmentDoc}`;

/**
 * __useGetStorePreBookingsQuery__
 *
 * To run a query within a React component, call `useGetStorePreBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorePreBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorePreBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStorePreBookingsQuery(baseOptions?: Apollo.QueryHookOptions<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>(GetStorePreBookingsDocument, options);
      }
export function useGetStorePreBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>(GetStorePreBookingsDocument, options);
        }
export function useGetStorePreBookingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>(GetStorePreBookingsDocument, options);
        }
export type GetStorePreBookingsQueryHookResult = ReturnType<typeof useGetStorePreBookingsQuery>;
export type GetStorePreBookingsLazyQueryHookResult = ReturnType<typeof useGetStorePreBookingsLazyQuery>;
export type GetStorePreBookingsSuspenseQueryHookResult = ReturnType<typeof useGetStorePreBookingsSuspenseQuery>;
export type GetStorePreBookingsQueryResult = Apollo.QueryResult<GetStorePreBookingsQuery, GetStorePreBookingsQueryVariables>;
export const GetStoresDocument = gql`
    query getStores {
  stores {
    nodes {
      ...BasicStore
    }
  }
}
    ${BasicStoreFragmentDoc}`;

/**
 * __useGetStoresQuery__
 *
 * To run a query within a React component, call `useGetStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoresQuery(baseOptions?: Apollo.QueryHookOptions<GetStoresQuery, GetStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoresQuery, GetStoresQueryVariables>(GetStoresDocument, options);
      }
export function useGetStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoresQuery, GetStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoresQuery, GetStoresQueryVariables>(GetStoresDocument, options);
        }
export function useGetStoresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoresQuery, GetStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoresQuery, GetStoresQueryVariables>(GetStoresDocument, options);
        }
export type GetStoresQueryHookResult = ReturnType<typeof useGetStoresQuery>;
export type GetStoresLazyQueryHookResult = ReturnType<typeof useGetStoresLazyQuery>;
export type GetStoresSuspenseQueryHookResult = ReturnType<typeof useGetStoresSuspenseQuery>;
export type GetStoresQueryResult = Apollo.QueryResult<GetStoresQuery, GetStoresQueryVariables>;
export const GetStylistsDocument = gql`
    query getStylists($onlyCheckedOut: Boolean) {
  stylists(onlyCheckedOut: $onlyCheckedOut) {
    nodes {
      ...CompleteStylist
    }
  }
}
    ${CompleteStylistFragmentDoc}`;

/**
 * __useGetStylistsQuery__
 *
 * To run a query within a React component, call `useGetStylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStylistsQuery({
 *   variables: {
 *      onlyCheckedOut: // value for 'onlyCheckedOut'
 *   },
 * });
 */
export function useGetStylistsQuery(baseOptions?: Apollo.QueryHookOptions<GetStylistsQuery, GetStylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStylistsQuery, GetStylistsQueryVariables>(GetStylistsDocument, options);
      }
export function useGetStylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStylistsQuery, GetStylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStylistsQuery, GetStylistsQueryVariables>(GetStylistsDocument, options);
        }
export function useGetStylistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStylistsQuery, GetStylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStylistsQuery, GetStylistsQueryVariables>(GetStylistsDocument, options);
        }
export type GetStylistsQueryHookResult = ReturnType<typeof useGetStylistsQuery>;
export type GetStylistsLazyQueryHookResult = ReturnType<typeof useGetStylistsLazyQuery>;
export type GetStylistsSuspenseQueryHookResult = ReturnType<typeof useGetStylistsSuspenseQuery>;
export type GetStylistsQueryResult = Apollo.QueryResult<GetStylistsQuery, GetStylistsQueryVariables>;
export const BookingUpdateDocument = gql`
    subscription bookingUpdate($uid: ID!) {
  bookingUpdate(uid: $uid) {
    ...CompleteBooking
  }
}
    ${CompleteBookingFragmentDoc}`;

/**
 * __useBookingUpdateSubscription__
 *
 * To run a query within a React component, call `useBookingUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBookingUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingUpdateSubscription({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useBookingUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<BookingUpdateSubscription, BookingUpdateSubscriptionVariables> & ({ variables: BookingUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BookingUpdateSubscription, BookingUpdateSubscriptionVariables>(BookingUpdateDocument, options);
      }
export type BookingUpdateSubscriptionHookResult = ReturnType<typeof useBookingUpdateSubscription>;
export type BookingUpdateSubscriptionResult = Apollo.SubscriptionResult<BookingUpdateSubscription>;
export const PreBookingUpdateDocument = gql`
    subscription preBookingUpdate($slug: String!) {
  preBookingUpdate(slug: $slug) {
    ...PreBookingUpdate
  }
}
    ${PreBookingUpdateFragmentDoc}`;

/**
 * __usePreBookingUpdateSubscription__
 *
 * To run a query within a React component, call `usePreBookingUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePreBookingUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreBookingUpdateSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePreBookingUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<PreBookingUpdateSubscription, PreBookingUpdateSubscriptionVariables> & ({ variables: PreBookingUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PreBookingUpdateSubscription, PreBookingUpdateSubscriptionVariables>(PreBookingUpdateDocument, options);
      }
export type PreBookingUpdateSubscriptionHookResult = ReturnType<typeof usePreBookingUpdateSubscription>;
export type PreBookingUpdateSubscriptionResult = Apollo.SubscriptionResult<PreBookingUpdateSubscription>;
export const ServiceExecutionUpdateDocument = gql`
    subscription serviceExecutionUpdate($slug: String!) {
  serviceExecutionUpdate(slug: $slug) {
    ...ServiceExecutionUpdate
  }
}
    ${ServiceExecutionUpdateFragmentDoc}`;

/**
 * __useServiceExecutionUpdateSubscription__
 *
 * To run a query within a React component, call `useServiceExecutionUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useServiceExecutionUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceExecutionUpdateSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useServiceExecutionUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<ServiceExecutionUpdateSubscription, ServiceExecutionUpdateSubscriptionVariables> & ({ variables: ServiceExecutionUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ServiceExecutionUpdateSubscription, ServiceExecutionUpdateSubscriptionVariables>(ServiceExecutionUpdateDocument, options);
      }
export type ServiceExecutionUpdateSubscriptionHookResult = ReturnType<typeof useServiceExecutionUpdateSubscription>;
export type ServiceExecutionUpdateSubscriptionResult = Apollo.SubscriptionResult<ServiceExecutionUpdateSubscription>;
export const StoreUpdateDocument = gql`
    subscription storeUpdate($slug: String!) {
  storeUpdate(slug: $slug) {
    ...SimpleStore
  }
}
    ${SimpleStoreFragmentDoc}`;

/**
 * __useStoreUpdateSubscription__
 *
 * To run a query within a React component, call `useStoreUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStoreUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreUpdateSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStoreUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<StoreUpdateSubscription, StoreUpdateSubscriptionVariables> & ({ variables: StoreUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StoreUpdateSubscription, StoreUpdateSubscriptionVariables>(StoreUpdateDocument, options);
      }
export type StoreUpdateSubscriptionHookResult = ReturnType<typeof useStoreUpdateSubscription>;
export type StoreUpdateSubscriptionResult = Apollo.SubscriptionResult<StoreUpdateSubscription>;
export const StylistUpdateDocument = gql`
    subscription stylistUpdate($slug: String!) {
  stylistUpdate(slug: $slug) {
    ...StylistUpdate
  }
}
    ${StylistUpdateFragmentDoc}`;

/**
 * __useStylistUpdateSubscription__
 *
 * To run a query within a React component, call `useStylistUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStylistUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStylistUpdateSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStylistUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<StylistUpdateSubscription, StylistUpdateSubscriptionVariables> & ({ variables: StylistUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StylistUpdateSubscription, StylistUpdateSubscriptionVariables>(StylistUpdateDocument, options);
      }
export type StylistUpdateSubscriptionHookResult = ReturnType<typeof useStylistUpdateSubscription>;
export type StylistUpdateSubscriptionResult = Apollo.SubscriptionResult<StylistUpdateSubscription>;